export default __webpack_public_path__ + "static/media/advertisment.f168455e.png";